module.exports = __webpack_public_path__ + "static/media/received_436266258860996 (1).8474d1e2.jpeg";